import dayjs from "dayjs";

export const firstDayOfMonth = dayjs().startOf("month");

export const lastDayOfMonth = dayjs().endOf("month");
